<template>
  <div class="app-header">
    <div class="header-left">
      <i
        class="collapse-btn"
        :class="collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
        @click="$emit('toggle-collapse')"
      />
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="(item, index) in breadcrumbs"
          :key="item.path + index"
        >
          <span v-if="index === breadcrumbs.length - 1">{{ item.meta.title }}</span>
          <router-link v-else-if="item.redirect !== 'noRedirect' && item.path" :to="item.redirect || item.path">
            {{ item.meta.title }}
          </router-link>
          <span v-else>{{ item.meta.title }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-right">
      <img
        v-if="showSeatIcon"
        class="header-icon"
        src="@/assets/icon/zuoxi.png"
        title="更换坐席邮箱"
        @click="$emit('change-email')"
      />
      <span class="welcome-text">{{ timeText }}，{{ displayName }}</span>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-dropdown">
          <el-image class="avatar" :src="avatar" fit="cover">
            <div slot="error" class="avatar-fallback"><i class="el-icon-user-solid"></i></div>
          </el-image>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="shopdata">
            <i class="el-icon-goods el-icon--left"></i>店铺资料
          </el-dropdown-item>
          <el-dropdown-item command="loginout" divided>
            <i class="el-icon-switch-button el-icon--left"></i>退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { resetRouter } from '@/router/index.js'
import router from '@/router/index.js'

export default {
  name: 'AppHeader',
  props: {
    collapse: Boolean,
  },
  data() {
    return {
      timeText: '您好',
      displayName: '',
      avatar: require('@/assets/icon/icon-menu.png'),
    }
  },
  computed: {
    breadcrumbs() {
      return this.$route.matched.filter(
        (item) => item.meta && item.meta.title && item.meta.layout != 0
      )
    },
    showSeatIcon() {
      return sessionStorage.getItem('loginPage') === '/arealogin'
    },
  },
  created() {
    this.loadUser()
    this.getTimeText()
  },
  methods: {
    loadUser() {
      const userinfo = JSON.parse(sessionStorage.getItem('userinfo') || '{}')
      this.displayName =
        userinfo.realname ||
        userinfo.nickname ||
        userinfo.shop_name ||
        userinfo.name ||
        '用户'
      if (userinfo.avatar_url) this.avatar = userinfo.avatar_url
    },
    getTimeText() {
      const h = new Date().getHours()
      if (h < 6) this.timeText = '夜深了'
      else if (h < 12) this.timeText = '早上好'
      else if (h < 14) this.timeText = '中午好'
      else if (h < 18) this.timeText = '下午好'
      else this.timeText = '晚上好'
    },
    handleCommand(command) {
      if (command === 'loginout') {
        const guardName = sessionStorage.getItem('guardName')
        const url =
          guardName === 'shop_user'
            ? '/api/shop/basic/logout'
            : '/api/manage/basic/logout'
        this.axios.get(url).finally(() => {
          const loginPage = sessionStorage.getItem('loginPage') || '/login'
          sessionStorage.removeItem('projectinfo')
          sessionStorage.removeItem('routestext')
          sessionStorage.removeItem('routes')
          sessionStorage.removeItem('userinfo')
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('guardName')
          resetRouter()
          this.$store.commit('routestatus', 0)
          this.$store.commit('tagsView/DEL_ALL_VIEWS')
          router.push({ path: loginPage })
        })
      }
      if (command === 'shopdata') {
        const guardName = sessionStorage.getItem('guardName')
        if (guardName === 'shop_user') {
          this.$router.push({ path: '/common/set/site' })
        } else {
          const loginPage = sessionStorage.getItem('loginPage')
          if (loginPage === '/arealogin') {
            this.$router.push({ path: '/haowu/manager/aunt/partner' })
          } else {
            this.$router.push({ path: '/admin/account/index' })
          }
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
.app-header {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  box-sizing: border-box;
}
.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}
.collapse-btn {
  font-size: 20px;
  cursor: pointer;
  margin-right: 12px;
  color: #606266;
  flex-shrink: 0;
  &:hover {
    color: #409eff;
  }
}
.header-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.welcome-text {
  font-size: 13px;
  color: #606266;
  margin-right: 16px;
}
.user-dropdown {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.avatar-fallback {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  border-radius: 50%;
  color: #909399;
}
.header-icon {
  width: 18px;
  height: 18px;
  margin-right: 12px;
  cursor: pointer;
  opacity: 0.85;
  &:hover {
    opacity: 1;
  }
}
</style>
